import React, { Component } from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import { FormattedMessage } from 'react-intl';
import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import isEqual from 'react-fast-compare';
import { email as isValidEmail } from '@/utils/validation';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './FollowSearchForm.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type Props = {
    error: string;
    preSubmitButtonText: any;
    setEmail: Function;
    submit: Function;
    submitted: boolean;
};

type State = {
    agree: boolean;
    email: string;
    emailValid: boolean;
};

export default class FollowSearchForm extends Component<Props, State> {
    state = {
        agree: false,
        email: '',
        emailValid: true,
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    onValueChange = (event: any) => {
        const newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState);
    };

    onAgreeValueChange = (event: any) => {
        const newState = { agree: event.target.checked };
        this.setState(newState);
    };

    onSignUp = () => {
        const email = this.state.email.trim();
        const emailValid = isValidEmail(email);
        const agree = this.state.agree;
        this.setState({ emailValid });
        if (emailValid) {
            this.props.setEmail(email);
            this.props.submit(email, agree);
        }
    };

    render() {
        const { error, preSubmitButtonText, submitted } = this.props;

        const { agree, email, emailValid } = this.state;

        let errorMessage: React.ReactNode = '';
        const errorOnPage = !emailValid || error;

        const tosLink = (
            <Link rel="noopener" target="_blank" to="/termsandconditions">
                <FormattedMessage id="signUpModal.termsLink" />
            </Link>
        );
        const privacyLink = (
            <Link rel="noopener" target="_blank" to="/privacy">
                <FormattedMessage id="signUpModal.privacyLink" />
            </Link>
        );
        const cookieLink = (
            <Link rel="noopener" target="_blank" to="/cookie-policy">
                <FormattedMessage id="signUpModal.cookieLink" />
            </Link>
        );

        if (!emailValid) {
            errorMessage = <FormattedMessage id="signUpModal.invalidEmail" />;
        } else if (error) {
            errorMessage = <FormattedMessage id="signUpModal.error" />; // we could show the error
        }
        return (
            <div className={styles.body}>
                <Input
                    autoComplete="email"
                    className={styles.emailInput}
                    e2e="joinModalEmail"
                    errorMessage={errorMessage}
                    id="email"
                    label={
                        <Text caption className={styles.emailLabelText}>
                            <FormattedMessage id="followSearchModal.emailAddress" />
                        </Text>
                    }
                    labelClassName={styles.emailLabel}
                    onChange={this.onValueChange}
                    valid={!errorOnPage}
                />
                <Checkbox
                    className={styles.termsWrap}
                    label={
                        <Text className={styles.termsText} h6>
                            <FormattedMessage
                                id="signUpModal.acceptText"
                                values={{ cookieLink, privacyLink, tosLink }}
                            />
                        </Text>
                    }
                    name="agreeTerms"
                    onChange={this.onAgreeValueChange}
                    startChecked={agree}
                />
                <div className={styles.actions}>
                    <Button
                        className={styles.submit}
                        disabled={submitted || !email || !agree}
                        e2e="joinModalStartNow"
                        onClick={this.onSignUp}
                        primary
                        red
                    >
                        {!submitted ? preSubmitButtonText : <Throbber colorWhite />}
                    </Button>
                </div>
            </div>
        );
    }
}
